module.exports = __webpack_public_path__ + "img/07.92213bfd.png";